export function getInfoTabPath(tab: string): string {
  return `/info/${tab}`;
}
